import { uuid } from './uuid';

/**
 * Returns the app instance ID stored in sessionStorage or generates a new one if not present.
 *
 * Checks if there is a 'GLOBAL_APP_ID' global variable set, returns it if present.
 * Checks if there is an 'app_instance_id' value in sessionStorage, returns it if present.
 * Otherwise, generates a new UUID via the uuid() function, stores it in sessionStorage,
 * and returns the new id.
 *
 * Logs messages indicating if the ID is reused or newly generated.
 *
 * The app instance ID uniquely identifies each browser tab instance of the app.
 *
 * @returns {string} The app instance ID
*/
export const getAppInstanceId = () => {
  let appInstanceId;

  if (window.GLOBAL_APP_ID) {
    appInstanceId = window.GLOBAL_APP_ID;
    return appInstanceId;
  }

  if (sessionStorage.getItem('app_instance_id')) {
    console.log('Bot running with a shared app instance ID retrieved from sessionStorage.');
    appInstanceId = sessionStorage.getItem('app_instance_id');
    return appInstanceId;
  }

  console.log('Bot running without a parent app instance ID. Generating a new one.');

  appInstanceId = uuid();

  sessionStorage.setItem('app_instance_id', appInstanceId);

  return appInstanceId;
};
